// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header .rect2 {
  width: 3px;
  height: calc(16 * var(--width-ratio));
  background: var(--ion-color-primary-tint);
  border-radius: 10px;
  margin-right: 5px;
}

.related-item {
  margin-top: 10px;
  font-size: 18px;
  line-height: 26px;
  text-decoration-line: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/related-post/related-post.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;EACA,qCAAA;EACA,yCAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AADF","sourcesContent":[".header {\n  .rect2 {\n    width: 3px;\n    height: calc(16 * var(--width-ratio));\n    background: var(--ion-color-primary-tint);\n    border-radius: 10px;\n    margin-right: 5px;\n  }\n}\n\n.related-item {\n  margin-top: 10px;\n  font-size: 18px;\n  line-height: 26px;\n  text-decoration-line: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
